import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import { useAlert } from 'react-alert'
import { parseSurveyJson } from "../../common_components/SurveyHelpers";
import { MappedRows } from "../../missions_components/sub_page_components/SurveyOverviewCard";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { SecondaryButton, NewPrimaryButton, PurpleSecondaryButton } from "../../common_components/Buttons";



// Api Calls
import SurveyAPI from "../../../api/api_calls/SurveyAPI";

function ScreenerReview(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);


    const [loadingScreener, setLoadingScreener] = useState(true);
    const [surveyJson, setSurveyJson] = useState({});
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [questionCount, setQuestionCount] = useState(-1);
    const [screeningQuestionCount, setScreeningQuestionCount] = useState(-1);




    // const [sessionLength, setSessionLength] = useState(-1);
    // const [numberRespondents, setNumberRespondents] = useState(-1);
    // const [videoRequired, setVideoRequired] = useState(false);
    // const [colleagues, setColleagues] = useState("");

    // const sessionLengthTooltip = "The length of each feedback session."
    // const numberRespondentsTooltip = "The total number of sessions you'd like to have"
    // const videoRequiredTooltop = "Is the respondent required to turn on video for the session?"
    // const colleagesTooltip = "Colleagues that will also receive calendar invites for sessions. They will not automatically be invited to this platform. Type in their emails separated by commas."


    useEffect(() => {
        async function getScreener() {
            const response = await SurveyAPI.showScreener({ missionId: missionId, handleRedirect: navigate });
            if (response.success) {
                if (response.survey_exists) {
                    setSurveyJson(response.survey_json);
                    setSurveyQuestions(parseSurveyJson(response.survey_json))
                    setQuestionCount(response.question_count);
                    setScreeningQuestionCount(response.screening_question_count);
                    setLoadingScreener(false);
                } else {
                    setSurveyJson({});
                    setQuestionCount(0);
                    setScreeningQuestionCount(0);
                    setLoadingScreener(false);
                }
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        // Set the path for the button if there's a direct link.
        getScreener();
    }, [])

    const isScreener = true;
    const navigateUrl = isScreener ? `/missions/${missionId}/screener` : `/missions/${missionId}/survey`
    const returnUrl = isScreener ? `/createmission/${missionId}/audience` : `/createmission/${missionId}/survey`

    function CTAButton() {
        if (!loadingScreener && questionCount > 0) {
            return (
                <PurpleSecondaryButton text="Edit Screener" onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />
            )
        } else if (!loadingScreener && questionCount === 0) {
            return (
                <PurpleSecondaryButton text="+ Create Screener" onClick={() => navigate(navigateUrl, { state: { afterSavePath: returnUrl } })} />
            )
        }
    }


    return (
        <div className="audience-requirements-card">
            <div className="empty-audience-screener-card">
                <div className="audience-requirements-card-title-and-subtitle">
                    <div className="audience-requirements-card-title">
                        Screener
                    </div>
                    {questionCount == 0 && <div className="audience-requirements-card-subtitle">
                        This mission does not have any screener questions yet.
                    </div>
                    }
                </div>
                {CTAButton()}
            </div>
            {questionCount > 0 &&
                <>
                    <div className="screener-title-row">
                        <div className="screener-title">Question List</div>
                        {isScreener && <div className="screener-title right">Includes (in)correct answers?</div>}
                    </div>
                    <div className="screener-question-list-container">
                        <MappedRows surveyQuestions={surveyQuestions} questionCount={questionCount} showScreener={isScreener} />
                    </div>
                    {isScreener && questionCount > 5 ?
                        <div className="screener-callout-badge-new">
                            We recommend including 5 or fewer questions.
                        </div>
                        : <div />
                    }
                </>
            }
            {
                loadingScreener && <CenteredLoadingIcon />
            }
        </div>


    )
}



export default ScreenerReview;